/**
 * Calculates loan values based on params from loan application
 * @param loanAmount
 * @param periodInMonths
 * @param apr
 * @param interestRate
 * @returns object with values loanAmount, periodInMonths, instalment, totalAmount, totalCost
 */
export function CalculateLoanExampleEs(
    loanAmount: number,
    periodInMonths: number,
    apr: number, //APR or effective interest rate (TAE)
    interestRate: number, //Interest rate (TIN)
) {
    let rate = interestRate

    //Monthly installment
    let repayment = calculateInstallment(loanAmount, periodInMonths, rate)
    let instalment = roundToDecimalUpwards(repayment, 0)

    //Total amount
    let totalAmount = calculateTotalAmount(loanAmount, periodInMonths, rate)
    let totalCost = totalAmount - loanAmount

    return {
        loanAmount: loanAmount,
        periodInMonths: periodInMonths,
        instalment: instalment,
        totalAmount: totalAmount,
        totalCost: totalCost,
    }
}

function calculateInstallment(
    loanAmount: number, //Loan Amount
    period: number, //Period
    rate: number //Interest rate
) {
    let installment = PMT(rate / 12, period, loanAmount, 0, 0)
    return -installment
}

function PMT(
    rate: number,
    nper: number,
    pv: number,
    fv: number = 0,
    type: number = 0
) {
    if (rate === 0) return -(pv + fv) / nper

    const pvif = Math.pow(1 + rate, nper)
    let pmt = (rate / (pvif - 1)) * -(pv * pvif + fv)

    if (type === 1) {
        pmt /= 1 + rate
    }

    return pmt
}

function calculateTotalAmount(
    loanAmount: number, //Loan Amount
    period: number, //Period
    rate: number //Interest rate
) {
    let sum = 0
    for (var i = 1; i <= period; i++) {
        //Period in months
        sum += calculateInstallment(loanAmount, period, rate) //Loan amount, period in months, rate
    }
    const totalAmount = Math.ceil(sum)

    return totalAmount
}

function roundToDecimalUpwards(number: number, decimals: number) {
    const multiplier = Math.pow(10, decimals)
    return Math.ceil(number * multiplier) / multiplier
}